import {useEffect, useState,useCallback,useRef} from "react"
// context custom hook
import {useAuthContext} from "./useAuthContext"
import {API_URL} from "../constants"

export const useLogout = () => {
   // get the dispatch function of the auth context,
   // this will let us change the state of the reducer
   const {dispatch,user} = useAuthContext()
   // state for different values
   const [error, setError] = useState<null | string>(null)
   const [isPending, setIsPending] = useState(false)
   // const [isCancelled, setIsCancelled] = useState(false)
   const isCancelledRef = useRef(false)

   // function called when the button of the navabr is clicked
   const logout = useCallback(async () => {
      setError(null)
      setIsPending(true)

      // sign the user out
      try {
         if (!user?.uid) {
            if (dispatch) dispatch({type: "LOGOUT"})
            if (!isCancelledRef.current) {
               setIsPending(false)
               setError(null)
            }
            return
         }
         await fetch(`${API_URL}/usuarios/logout`, {
            method: "POST",
            headers: {
               "Content-Type": "application/json",
            },
            credentials: "include",
            body : JSON.stringify({uid : user.uid})
         })
         // dispatch logout action
         if (dispatch) {
            dispatch({type: "LOGOUT"})
         } else {
            console.error("Dispatch is not available")
         }

         if(!isCancelledRef.current)
         {
            setIsPending(false)
            setError(null)
         }

      } catch (error) {

         // Intentar dispatch pero con verificación
         if (dispatch) {
            dispatch({type: "LOGOUT"})
         }

         if (!isCancelledRef.current) {
            setError("Could not logout from server, but logged out locally")
            setIsPending(false)
         }
      }
   },[dispatch, user?.uid])

   // if it gets cancellled, it stops the execution
   useEffect(() => {
      isCancelledRef.current = false
      return () => {
         isCancelledRef.current = true
      }
   }, [])

   return {logout, isPending, error}
}
